import React from 'react'
import { Link } from 'react-router-dom'

const AdminMenu = () => {
  return (
    <div className='admin-dashboard'>
      {/* Sección principal */}
      <div className="seccion-dashboard">
        <h2 className="titulo-seccion">Vista general</h2>
        <div className="grid-dashboard principal">
          <Link to="/dashboard/calendario" className="card-dashboard destacada">
            <img src="/images/calendario-reloj.svg" alt="Calendario" />
            <div className="card-contenido">
              <h3>Calendario de citas</h3>
              <p>Visualiza todas las reservas ordenadamente</p>
            </div>
          </Link>

          <Link to="/dashboard/finanzas" className="card-dashboard destacada">
            <img src="/images/grafico-histograma.svg" alt="Finanzas" />
            <div className="card-contenido">
              <h3>Finanzas</h3>
              <p>Estadísticas y análisis de tu negocio</p>
            </div>
          </Link>
        </div>
      </div>

      {/* Gestión de citas */}
      <div className="seccion-dashboard">
        <h2 className="titulo-seccion">Gestión de citas</h2>
        <div className="grid-dashboard">
          <Link to="/dashboard/asistencias" className="card-dashboard">
            <img src="/images/lista-de-verificacion.svg" alt="Asistencias" />
            <div className="card-contenido">
              <h3>Asistencias</h3>
              <p>Confirma asistencias para el recuento de ingresos</p>
            </div>
          </Link>

          <Link to="/dashboard/clientes" className="card-dashboard">
            <img src="/images/atencion-al-cliente.svg" alt="Clientes" />
            <div className="card-contenido">
              <h3>Clientes</h3>
              <p>Información de tus clientes</p>
            </div>
          </Link>

          <Link to="/dashboard/bloqueados" className="card-dashboard">
            <img src="/images/prohibicion.svg" alt="Bloqueados" />
            <div className="card-contenido">
              <h3>Bloqueados</h3>
              <p>Administra usuarios bloqueados</p>
            </div>
          </Link>
        </div>
      </div>

      {/* Configuración */}
      <div className="seccion-dashboard">
        <h2 className="titulo-seccion">Configuración</h2>
        <div className="grid-dashboard">
          <Link to="/dashboard/servicios" className="card-dashboard">
            <img src="/images/tijeras-azul.svg" alt="Servicios" />
            <div className="card-contenido">
              <h3>Servicios</h3>
              <p>Añade, edita o elimina servicios</p>
            </div>
          </Link>

          <Link to="/dashboard/horario-de-trabajo" className="card-dashboard">
            <img src="/images/reloj-azul.svg" alt="Horario" />
            <div className="card-contenido">
              <h3>Horario de trabajo</h3>
              <p>Establece tu horario de trabajo</p>
            </div>
          </Link>

          <Link to="/dashboard/dias-especiales" className="card-dashboard">
            <img src="/images/dia-de-la-casa.svg" alt="Días especiales" />
            <div className="card-contenido">
              <h3>Días especiales</h3>
              <p>Configura días festivos o horarios especiales</p>
            </div>
          </Link>

          <Link to="/dashboard/ajustes-del-sistema" className="card-dashboard">
            <img src="/images/ajuste.svg" alt="Ajustes" />
            <div className="card-contenido">
              <h3>Ajustes del sistema</h3>
              <p>Configura los ajustes del sistema de citas</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AdminMenu
